import { Panel } from '../ui/Panel';
import { AppointmentRow } from './AppointmentRow';
import { NewAppointment } from './NewAppointment';
import { CourseCard } from './CourseCard';
import { useAdmin } from '../AdminContext';
import { appointmentStart } from '../../utils/account';
import { dayMedium, newestFirst } from '../../core/format/dates';
import { staffList, staffName } from '../../core/rules/salonDays';
import type { CustomerFileControl } from './useCustomerFile';

/** Afspraken, kuur en bezoeken van één klant. */
export function AppointmentsPanel({
  ctl
}: {
  ctl: CustomerFileControl;
}) {
  const {
    account
  } = ctl.file;
  const {
    index,
    site
  } = useAdmin();
  const team = staffList(site.staff);
  const shared = team.length > 1;
  const appointments = [...account.appointments].sort((a, b) => appointmentStart(a).getTime() - appointmentStart(b).getTime());
  const visits = newestFirst(account.visits);
  return <div className="grid gap-6 lg:grid-cols-3" data-id="element-1049" data-mp="606xkrpn14n7">
      <div className="min-w-0 space-y-6 lg:col-span-2" data-id="element-1050" data-mp="60yuc5uz18f2">
        <Panel title="Afspraken" flush data-id="element-1051" data-mp="6joke5jjel5t">
          {appointments.length === 0 ? <p className="px-4 py-6 text-[14px] text-muted sm:px-5" data-id="element-1052" data-mp="1ld69im7lohs">Geen afspraken gepland.</p> : <ul className="divide-y divide-line" data-id="element-1053" data-mp="gix8wivmv7ks">
              {appointments.map(a => <AppointmentRow key={a.id} appt={a} ctl={ctl} data-id="element-1054" data-mp="birnvljvcjbo" />)}
            </ul>}
        </Panel>
        <NewAppointment ctl={ctl} data-id="element-1055" data-mp="pi0rzmusvmza" />
      </div>

      <div className="min-w-0 space-y-6" data-id="element-1056" data-mp="pgpnfktj6b74">
        <CourseCard ctl={ctl} data-id="element-1057" data-mp="kkr5aeysppf5" />
        <Panel title="Bezoeken" description={visits.length ? `${visits.length} keer in de salon geweest.` : undefined} flush data-id="element-1058" data-mp="kjfzyappc9lx">
          {visits.length === 0 ? <p className="px-4 py-6 text-[14px] text-muted sm:px-5" data-id="element-1059" data-mp="u9iuifch1vmd">Nog nooit in de salon geweest.</p> :
        // Kan lang worden: eigen scrollgebied, met toetsenbord te bereiken.
        <ul className="max-h-80 divide-y divide-line overflow-y-auto" tabIndex={0} aria-label="Bezoeken" data-id="element-1060" data-mp="148rkyy84os3z">
              {visits.map((v, i) => <li key={`${v.date}-${i}`} className="flex items-start justify-between gap-3 px-4 py-3 text-[14px] sm:px-5" data-id="element-1061" data-mp="1b92680v9knoy" data-mpi={i}>
                  <span className="min-w-0" data-id="element-1062" data-mp="1l9malce2y8be">
                    <span className="block truncate text-ink" data-id="element-1063" data-mp="1l7rnpsj9064o">{index.treatmentBySlug(v.treatmentSlug)?.name ?? v.treatmentSlug}</span>
                    {/* Gedeelde salon: wie het deed. Een bezoek zonder `staffId` (van vóór de collega) is van Sarah. */}
                    {shared && <span className="block text-[12px] text-muted" data-id="element-1064" data-mp="1z07saxrssc7p">Behandeld door {staffName(team, v.staffId)}</span>}
                  </span>
                  <span className="shrink-0 text-[13px] tabular-nums text-muted" data-id="element-1065" data-mp="240lsjtn5qhv6">{dayMedium(v.date)}</span>
                </li>)}
            </ul>}
        </Panel>
      </div>
    </div>;
}